/**
 * =============================================================================
 * async-product-tiles.js
 * =============================================================================
 * Fetch product tiles based on handles, and optionally generate a grid or
 * carousel of these tiles.
 * =============================================================================
 */

var AsyncProductTiles = {
  view: "product-tiles",

  default: {
    presentation: "stack",
    limit: 6
  },

  /**
   * Render the panel(s)
   * 
   * @param {Array} handles
   * @param {HTMLElement} container
   * @returns {Promise}
   */
  render(handles, container) {
    let url = this.buildFetchUrl(handles);
    return this.fetchTiles(url, container);
  },

  /**
   * Generate a fetch URL to the /search raw view (template)
   * 
   * @param {Array} handles 
   * @returns {String} URL to fetch
   */
  buildFetchUrl(handles) {
    let prefixedHandles = handles.map(e => `handle:${e}`).join("+OR+");
    return `/search?q=${prefixedHandles}&type=product&view=${this.view}`;
  },

  /**
   * Perform a fetch from the server
   * 
   * @param {String} url
   * @param {HTMLElement} container
   */
  fetchTiles(url, container) {
    const fetchPromise = fetch(url).then(response => response.json());
    fetchPromise.then(response => this.onFetchedTiles(response.tiles, container));
    return fetchPromise;
  },

  /**
   * Generate tiles for the fetched products
   * 
   * @param {Array} tiles HTML tiles returned from fetch
   * @param {HTMLElement} container
   */
  onFetchedTiles(tiles, container) {
    MP.Log("[A-P-T] onFetchedTiles", tiles, container);

    if(tiles.length > 0 && container){
      let presentation = container.querySelector("[data-presentation]")?.dataset.presentation || this.default.presentation;
      let limit = container.querySelector("[data-limit]")?.dataset.limit || this.default.limit;
      let limitedTiles = tiles.slice(0, limit);
      let tileContainer = container.querySelector(".tile-container");

      switch(presentation) {
        case "stack":
          tileContainer.innerHTML = "";
          limitedTiles.forEach(tile => {
            tileContainer.insertAdjacentHTML('beforeend', `<div>${tile}</div>`);
          });
          break;
        case "carousel":
          let carousel = container.querySelector(".tile-carousel");
          let carouselSlides = carousel.querySelector(".swiper-wrapper");
          limitedTiles.forEach(tile => {
            carouselSlides.insertAdjacentHTML('beforeend', `<div class="swiper-slide"><div class="px-1">${tile}</div></div>`);
          });
          tileContainer.remove();
          carousel.classList.remove("d-none");
          break;
      }

      // Generate the necessary offcanvas elements for the tile
      container.querySelectorAll(`script[id^='offcanvas-injection--']`).forEach(e => {
        (0, eval)(e.innerText);
      });
      mp_lazyload_setup();
    } else {
      container?.remove();
    }
  }
}

export default AsyncProductTiles;